import axios, { AxiosError } from 'axios';


// ایجاد instance از axios
const apiClient = axios.create({

  baseURL: 'https://hami.imhh.ir:3200',
    headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true // برای ارسال کوکی/اعتبارنامه
});

// اینترسپتور برای افزودن توکن
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("authUser");
  if (token) {
      const cleanToken = token.replace(/^"|"$/g, '');
    config.headers.Authorization = `Bearer ${cleanToken}`;
  }
  return config;
});

// اینترسپتور برای مدیریت خطاها
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("authUser");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export async function apiFetch(options = {}) {
  try {
    const response = await apiClient({
      url: 'common',
      method: 'POST',
      ...options
    });

    return response.data;

  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response) {
      console.error(`Server responded with: ${axiosError.response}`);

    } else {
     console.error('Network error or server not responding');
    }
  }
}